<template>
  <div class="home">
    <top-banner></top-banner>
    <div class="main">
      <middle-text></middle-text>
      <div class="middleTextBg" v-if="pageConfig.id == 8">
        <img src="../../assets/icon/bannergg.png" alt="" />
      </div>
      <div class="middleTextBgm" v-if="pageConfig.id == 8">
        <img src="../../assets/icon/mhhbanner.png" alt="" />
      </div>
      <div class="middleTextBg" v-if="pageConfig.id == 14">
        <img src="../../assets/activity/bg.png" alt="" />
      </div>
      <div class="middleTextBgm" v-if="pageConfig.id == 14">
        <img src="../../assets/activity/bgggm.png" alt="" />
      </div>
      <middle-banner v-for="(item, index) in baseHots" :key="index" :hotinfo="item"></middle-banner>
      <!-- <middle-bannerUsa></middle-bannerUsa>
      <middle-bannerAsia></middle-bannerAsia>
      <middle-bannerEur></middle-bannerEur> -->
    </div>

    <NewFooter></NewFooter>
  </div>
</template>

<script>
import { getNowFormatDate, filter_date } from "./utils.js"
import NewFooter from "@/components/footer/newfooter.vue"
import TopBanner from "@/components/home/topBanner/topBanner.vue"
import middleText from "@/components/home/middleText/middleText.vue"
import MiddleBanner from "@/components/home/middleBanner/middleBanner.vue"
import { getHotlines } from "@/api/index"
import { mapState } from "vuex"
export default {
  name: "home",
  data() {
    return {
      baseHots: [],
    }
  },
  components: {
    NewFooter,
    TopBanner,
    middleText,
    MiddleBanner,
  },
  computed: mapState({
    pageConfig: (state) => state.common.pageConfig,
  }),
  created() { },
  watch: {
    pageConfig: {
      handler(newV) {
        if (!newV?.id) return
        this.getHots()
      },
      immediate: true,
    },
  },
  methods: {
    //获取热门航线
    getHots() {
      getHotlines().then((res) => {
        if (res.status !== 200) {
          return
        }

        // console.log(this.baseHots);
        const currency = (prices) => {
          const currencys = this.pageConfig.default_currency.split(",").map((currency) => {
            return [currency, `${currency} ${prices[`price${currency}`]?.toFixed(2)}+`]
          })
          return Object.fromEntries(currencys)
        }
        res.data.map((item) => {
          item.content = item.content.map((item1) => {
            return {
              img: item1.image,
              title: {
                left: item1.arr_city,
                right: ``,
              },
              desc: {
                left: `From ${item1.dep_city}`,
                right: filter_date(getNowFormatDate(item1.dep_times)), //日期
              },
              Currency: currency(item1),
              fromCity: `${item1.dep_city} (${item1.dep_code})`,
              arrCity: `${item1.arr_city} (${item1.arr_code})`,
              fromCityCode: item1.dep_code,
              arrCityCode: item1.arr_code,
              newDate: getNowFormatDate(item1.dep_times),
            }
          })
        })
        this.baseHots = res.data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./home.scss";
@import "./mhome.scss";
</style>
